import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import TaskCard from "./TaskCard";
import { useDroppable } from "@dnd-kit/core";
import InfiniteScroll from "react-infinite-scroll-component";
import { Checkbox, Spin } from "antd";

const KanbanColumn = ({
  column,
  tasks,
  fetchMoreTasks,
  hasMore,
  onTaskClick,
  onEditTask,
  onCloneTask,
  onTransferTask,
  onDelete,
  onAssigneeClick,
  isMultiSelectMode,
  selectedTaskIds,
  onToggleSelect,
}) => {
  const { setNodeRef } = useDroppable({
    id: column.key, // column becomes drop target
  });


  const isCompleted = column.title === "Completed";

  return (
    <div ref={setNodeRef} className="kanban-column-custom">
      <div className="column-header">
        <div className="column-title">
          {isMultiSelectMode && !isCompleted && (
            <Checkbox
              checked={
                tasks.length > 0 &&
                tasks.every((t) => selectedTaskIds.includes(t.id))
              }
              indeterminate={
                tasks.some((t) => selectedTaskIds.includes(t.id)) &&
                !tasks.every((t) => selectedTaskIds.includes(t.id))
              }
              onChange={(e) => {
                const checked = e.target.checked;

                if (checked) {
                  // select all tasks in this column
                  const columnTaskIds = tasks.map((t) => t.id);

                  onToggleSelect(columnTaskIds, true);
                } else {
                  // deselect all tasks in this column
                  const columnTaskIds = tasks.map((t) => t.id);

                  onToggleSelect(columnTaskIds, false);
                }
              }}
            />
          )}
          <span className="status-dot" style={{ background: column.dot }} />
          <h6 className="fw-bold mb-0 pb-0 text-xxs">{column.title}</h6>
          <span className="task-count">{tasks.length}</span>
        </div>

        <PlusOutlined className="column-add" />
      </div>

      <div id={`scrollable-${column.key}`} className="column-content">
        <InfiniteScroll
          dataLength={tasks.length}
          next={fetchMoreTasks}
          hasMore={hasMore}
          loader={
            <div
              style={{ display: "flex", justifyContent: "center", padding: 12 }}
            >
              <Spin size="small" />
            </div>
          }
          scrollableTarget={`scrollable-${column.key}`}
        >
          {tasks.map((task) => {
            const isSelected = selectedTaskIds?.includes(task.id);

            return (
              <TaskCard
                key={task.id}
                task={task}
                onClick={() => onTaskClick(task)}
                onEditTask={onEditTask}
                onCloneTask={onCloneTask}
                onTransferTask={onTransferTask}
                onDelete={onDelete}
                onAssigneeClick={onAssigneeClick}
                isMultiSelectMode={isMultiSelectMode}
                isSelected={isSelected}
                onToggleSelect={onToggleSelect}
              />
            );
          })}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default KanbanColumn;
